










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { UserReview } from '@/models/user-review'
import { UserReviewListQuery, UserReviewService } from '@/services/user-review'
import { log } from '@spa/log'

import OpenPostReviewModalButton from './OpenPostReviewModalButton.vue'
import Pagination from './Pagination.vue'
import UserReviewList from './UserReviewList.vue'

@Component({
  components: {
    OpenPostReviewModalButton,
    UserReviewList,
    Pagination,
  },
})
export default class UserReviewArea extends Vue {
  @Prop({ required: true })
  rootId: string

  @Prop({ required: true })
  brand: string

  userReviewService: UserReviewService = UserReviewService.createForBrand(this.brand)

  totalReviewCount: number | null = null
  limitPerPage: number = 10
  currentPage: number = 1
  reviewList: UserReview[] = []
  loading: boolean = false

  userReviewError: UserReviewError | null = null

  async created() {
    this.loading = true
    try {
      await this.countRelatedToRoot()
      if (this.totalPageNumber >= 1) {
        await this.updateReviewList()
      }
    } catch (error) {
      this.userReviewError = {
        message: 'ユーザー レビュー情報を取得できませんでした',
      }
    } finally {
      this.loading = false
    }
  }

  async countRelatedToRoot(): Promise<void> {
    const result = await this.userReviewService.countRelatedToRoot(this.rootId)
    result.fold(
      (error) => {
        this.userReviewError = {
          message: 'ユーザー レビュー情報を取得できませんでした',
        }
        log.error('error fetching user review count', error)
      },
      value => this.totalReviewCount = value
    )
  }

  async updateReviewList(): Promise<void> {
    this.loading = true
    this.reviewList = []
    const query: UserReviewListQuery = {
      limit: this.limitPerPage,
      offset: this.offset,
    }
    const result = await this.userReviewService.listRelatedToRoot(this.rootId, query)
    result.fold(
      (error) => {
        this.userReviewError = {
          message: 'ユーザー レビュー情報を取得できませんでした',
        }
        log.error('error fetching user reviews', error)
      },
      value => this.reviewList = value
    )
    this.loading = false
  }

  get listIsEmpty(): boolean {
    return this.totalReviewCount === 0
  }

  get reviewQuantityLabel(): string {
    if (this.totalReviewCount === null) {
      return ''
    }
    if (this.totalReviewCount === 0) {
      return 'まだレビューがありません。<br/>あなたが最初のレビューを投稿しませんか？'
    }
    const start = this.offset + 1
    const limit = this.offset + this.limitPerPage
    const end = limit > this.totalReviewCount ? this.totalReviewCount : limit
    if (start === end) {
      return `${start}件目（全${this.totalReviewCount}件）`
    }

    return `${start}-${end}件目（全${this.totalReviewCount}件）`
  }

  get totalPageNumber(): number {
    return this.totalReviewCount === null ? 0 : Math.ceil(this.totalReviewCount / this.limitPerPage)
  }

  async previousClicked(): Promise<void> {
    this.scrollToTop()
    this.currentPage -= 1
    this.updateReviewList()
  }

  async nextClicked(): Promise<void> {
    this.scrollToTop()
    this.currentPage += 1
    this.updateReviewList()
  }

  private get offset(): number {
    return this.limitPerPage * (this.currentPage - 1)
  }

  private get userReviewAreaTop(): number {
    return (this.$refs.userReviewArea as HTMLElement).offsetTop
  }

  private get headerHeight(): number {
    // EcHeaderコンポーネントの高さをPropsでここまで持ってくるには遠すぎるので、力技で取得する
    return (document.getElementsByClassName('header__ec-header')[0] as HTMLElement).offsetHeight
  }

  private scrollToTop() {
    window.scrollTo({
      top: this.userReviewAreaTop - this.headerHeight,
      behavior: 'smooth',
    })
  }
}

interface UserReviewError {
  message: string
}
